import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
    const colorValue = semanticVariables?.[`semantic_icon_${color}`];
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M8.72832 1.04559C9.03629 1.01643 9.33057 1.17934 9.46934 1.45582L14.5735 11.6254C14.7242 11.9257 14.6569 12.2895 14.4087 12.516L3.63249 22.3468C3.38493 22.5727 3.01759 22.6069 2.73258 22.4306C2.44757 22.2544 2.31405 21.9105 2.40547 21.5881L8.07748 1.58763C8.16188 1.29001 8.42035 1.07476 8.72832 1.04559Z"
                fill={colorValue}
            />
            <path
                d="M15.6979 1.4606C16.0058 1.4316 16.2998 1.59449 16.4386 1.87083L21.5434 12.0404C21.6941 12.3407 21.6267 12.7046 21.3785 12.931L10.6017 22.7619C10.3543 22.9876 9.98714 23.0219 9.70216 22.8459C9.41719 22.6699 9.28346 22.3263 9.37448 22.004L10.7814 17.1758C10.8194 17.0412 10.8944 16.9198 10.9977 16.8256L15.2668 12.931C15.6804 12.5536 15.7738 11.86 15.5227 11.3595L13.6501 7.62853C13.5658 7.46068 13.5476 7.26733 13.599 7.0867L15.0469 2.00189C15.1316 1.70452 15.3901 1.48959 15.6979 1.4606Z"
                fill={colorValue}
            />
        </svg>
    );
};
